import React from 'react'
import { CheckBoxRounded } from '@mui/icons-material'
import {Badge, SubHeader} from '../..'

import './readMore.css'

const ReadMore = ({onOpen, onClose}: any) => {

  return (
    <>
        {onOpen && (
            <>
                <div className='read-more-modal-wrapper'>
                    <div className={onOpen ? "read-more-modal-container active": "read-more-modal-container"}>
                        <Badge title="About Us" />
                        <SubHeader title="What we do" description="A visual collection of our most recent works - each piece crafted with intention, emotion and style." />

                        <div className='read-more-main-container'>
                            <div className="read-more-main-cover">
                                <div className="read-more-main-box">
                                    <span className="read-more-main-grid">
                                        <CheckBoxRounded />
                                    </span>
                                    <span className="read-more-main-text">One workspace</span>
                                </div>
                                <div className="read-more-main-box">
                                    <span className="read-more-main-grid">
                                        <CheckBoxRounded />
                                    </span>
                                    <span className="read-more-main-text">One workspace</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </>
  )
}

export default ReadMore